import React from 'react';
import {
      CModal,
      CModalHeader,
      CModalBody,
      CModalFooter,
      CButton,
      CBadge
} from '@coreui/react';
import PropTypes from 'prop-types';

const PaymentStatusModal = ({ show, onHide, paymentDetails, onComplete }) => {
      const getStatusBadgeColor = (status) => {
            switch (status) {
                  case 'complete':
                        return 'success';
                  case 'pending':
                        return 'warning';
                  case 'failed':
                        return 'danger';
                  default:
                        return 'secondary';
            }
      };

      return (
            <CModal 
                  visible={show} 
                  onClose={onHide}
                  alignment="center"
            >
                  <CModalHeader closeButton>
                        <h5>Payment Status</h5>
                  </CModalHeader>
                  <CModalBody>
                        <div className="payment-details">
                              <div className="mb-3 text-center">
                                    <i className={`fas fa-${paymentDetails.status === 'complete' ? 'check-circle text-success' : 'info-circle text-warning'} fa-3x`}></i>
                              </div>
                              
                              <div className="mb-3">
                                    <strong>Status:</strong>{' '}
                                    <CBadge color={getStatusBadgeColor(paymentDetails.status)}>
                                          {paymentDetails.status}
                                    </CBadge>
                              </div>
                              
                              <div className="mb-3">
                                    <strong>Payment Status:</strong>{' '}
                                    <CBadge color={paymentDetails.payment_status === 'paid' ? 'success' : 'warning'}>
                                          {paymentDetails.payment_status}
                                    </CBadge>
                              </div>

                              {paymentDetails.customer_email && (
                                    <div className="mb-3">
                                          <strong>Email:</strong>{' '}
                                          <span className="mb-2">
                                                {paymentDetails.customer_email}
                                          </span>
                                    </div>
                              )}

                              {paymentDetails.message && (
                                    <div className="alert alert-info">
                                          {paymentDetails.message}
                                    </div>
                              )}
                        </div>
                  </CModalBody>
                  <CModalFooter>
                        <CButton 
                              color="secondary" 
                              onClick={onHide}
                        >
                              Close
                        </CButton>
                        {paymentDetails.status === 'complete' && (
                              <CButton 
                                    color="primary" 
                                    onClick={onComplete}
                              >
                                    View Orders
                              </CButton>
                        )}
                  </CModalFooter>
            </CModal>
      );
};

PaymentStatusModal.propTypes = {
      show: PropTypes.bool.isRequired,
      onHide: PropTypes.func.isRequired,
      paymentDetails: PropTypes.shape({
            status: PropTypes.string.isRequired,
            payment_status: PropTypes.string.isRequired,
            customer_email: PropTypes.string,
            message: PropTypes.string
      }).isRequired,
      onComplete: PropTypes.func.isRequired
};

export default PaymentStatusModal; 

